import { TextField } from '@material-ui/core';

import { CustomInputLabel } from '../../../../../components/CustomInputLabel';
import { FormRow } from '../../../../../components/Form/FormRow';
import { useUnsafeTranslation } from '../../../../../i18next';
import { EditComponentProps, ViewComponentProps } from '../types';

export const EditSectionFrom = ({ value, onChange }: EditComponentProps) => {
  const { t } = useUnsafeTranslation();
  return (
    <div>
      <FormRow>
        <CustomInputLabel label={t('Name')} fullWidth>
          <TextField
            value={value.data.from.name}
            onChange={(ev) =>
              onChange({
                ...value,
                data: {
                  ...value.data,
                  from: { ...value.data.from, name: ev.target.value }
                }
              })
            }
            fullWidth
            variant="outlined"
          />
        </CustomInputLabel>
      </FormRow>
      <FormRow>
        <CustomInputLabel label={t('Reply-to email address')} fullWidth>
          <TextField
            value={value.data.replyTo?.email}
            onChange={(ev) =>
              onChange({
                ...value,
                data: {
                  ...value.data,
                  replyTo: { ...value.data.from, email: ev.target.value }
                }
              })
            }
            fullWidth
            variant="outlined"
          />
        </CustomInputLabel>
      </FormRow>
    </div>
  );
};

export const ViewSectionFrom = ({ value }: ViewComponentProps) => {
  if (value.data.from.name && value.data.replyTo?.email) {
    return (
      <div>
        {value.data.from.name} • {value.data.replyTo.email}
      </div>
    );
  }
  if (value.data.from.name) {
    return <div>{value.data.from.name}</div>;
  }
  if (value.data.replyTo?.email) {
    return <div>{value.data.replyTo?.email}</div>;
  }
  return null;
};
